export enum FeatureFlagVariables {
  isBonusxUser = "is_bonusx_user",
  isElevenLabsWidgetAvailable = "is_eleven_labs_widget_available",
  iseeUniqueIdentifier = "isee_unique_identifier",
  dynamicPaywallProductId = "dynamic_paywall_product_id",
  isIncomeAvailable = "is_income_available",
  isRealEstatesAvailable = "is_real_estates_available",
  isAdminRedirectActive = "is_admin_redirect_active",
  aiDocumentValidationEnabledStructures = "ai_document_validation_enabled_structures",
  aiDocumentValidationEnabledServices = "ai_document_validation_enabled_services",
  aiDocValidationNaspiAbTest = "ai_doc_validation_naspi_ab_test",
  aiDocValidationNaspiAbTestStartDate = "ai_doc_validation_naspi_ab_test_start_date",
  householdMemberTaxCodeVariant = "household_member_tax_code_variant",
  confermaRequisitiExperimentVariant = "conferma_requisiti_experiment_variant",
  requisitesConfirmed730ExperimentVariant = "requisites_confirmed_730_experiment_variant",
}
